let scriptsLoaded = false;

const scripts = [
    "/js/jquery-2.2.4.min.js",
    "/js/plugins.js",
    "/js/bootstrap.min.js",
    "/js/wow.min.js",
    "/vendor/OwlCarousel/owl.carousel.min.js",
    "/js/jquery.meanmenu.min.js",
    "/js/jquery.scrollUp.min.js",
    "/js/waypoints.min.js",
    "/js/jquery.counterup.min.js",
    "/js/jquery.countdown.min.js",
    "/js/jquery.magnific-popup.min.js",
    "/js/isotope.pkgd.min.js",
    "/js/jquery.gridrotator.js",
    "/vendor/slider/js/jquery.nivo.slider.js",
    "/vendor/slider/home.js",
    "/js/main.js",
];

const loadScript = (src) => {
    return new Promise((resolve) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve();

        const s = document.createElement("script");
        s.src = src;
        s.async = false;
        s.onload = resolve;
        s.onerror = resolve;
        document.body.appendChild(s);
    });
};

export const loadTemplateScriptsOnce = async () => {
    if (scriptsLoaded) return;
    scriptsLoaded = true;

    console.log("Loading template scripts...");

    for (const src of scripts) {
        await loadScript(src);
        console.log("Loaded:", src);
    }

    console.log("All scripts loaded successfully");
};

export const reloadOnRouteChange = (pathname) => {
    // prevent reload loop on first load
    const lastPath = sessionStorage.getItem("lastPath");

    if (lastPath && lastPath !== pathname) {
        sessionStorage.setItem("lastPath", pathname);
        window.location.reload();
        return;
    }

    sessionStorage.setItem("lastPath", pathname);
};
